import { useState, useEffect } from "react";
import LeavesInfo from "features/leaves/LeavesInfo";
import { getEmployeeLeavesInfoByUser, getEmployeeLeavesDetailsByUser } from "api/apiHelper";
import { EmployeeLeaveInfoType, EmployeeLeavesDetailsType } from "types/leaves-types";
import LeavesStatusTable from "features/leaves/LeavesStatusTable";
import { useIsManager, usePermissions } from "app/hooks";
import EmployeesLeaves from "./Leaves";
import RequestLeaveForm from "features/leaves/RequestLeaveForm";

const LeavesDetails = () => {
  const [leaveInfo, setLeaveInfo] = useState<EmployeeLeaveInfoType[] | []>([]);
  const [leavesDetail, setLeavesDetail] = useState<EmployeeLeavesDetailsType[] | []>([]);
  const permissions = usePermissions() || [];
  const isManager = useIsManager() || false;
  const [showManageLeaves, setShowManageLeaves] = useState(false);
  const [showRequestLeave, setShowRequestLeave] = useState(false);

  const fetchLeaves = async () => {
    if (permissions && permissions.includes('leaves.view_my_employeeleaveinfo')) {
      try {
        const response = await getEmployeeLeavesInfoByUser();
        setLeaveInfo(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    if (permissions && permissions.includes('leaves.view_my_employeeleavesdetails')) {
      try {
        const response = await getEmployeeLeavesDetailsByUser();
        setLeavesDetail(response.data);
      } catch (error) {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    fetchLeaves();
  }, []);

  const handleCloseRequestLeave = () => {
    setShowRequestLeave(false);
    fetchLeaves();
  };

  const handleCloseManageLeaves = () => {
    setShowManageLeaves(false);
    fetchLeaves();
  };

  if (showManageLeaves) {
    return <EmployeesLeaves setShowManage={handleCloseManageLeaves} />;
  }

  if (showRequestLeave) {
    return <RequestLeaveForm setShowRequestLeave={handleCloseRequestLeave} />;
  }

  return (
    <div className="mt-5">
      <div className="mb-4 flex justify-end gap-3">
        <button
          className="bg-brand-500 flex gap-2 justify-center items-center uppercase hover:bg-brand-600 dark:bg-brand-400 dark:hover:bg-brand-500 rounded-lg px-4 py-3 text-[0.8rem] font-bold text-white"
          onClick={() => setShowRequestLeave(true)}
        >
          <i className="fas fa-plus text-[0.8rem] leading-none"></i>
          <span className="leading-none">Request Leave</span>
        </button>
        
        {(isManager || permissions.includes('leaves.view_employeeleavesdetails')) && (
          <button
            className="bg-brand-500 flex gap-2 justify-center items-center uppercase hover:bg-brand-600 dark:bg-brand-400 dark:hover:bg-brand-500 rounded-lg px-4 py-3 text-[0.8rem] font-bold text-white"
            onClick={() => setShowManageLeaves(true)}
          >
            <i className="fas fa-list text-[0.8rem] leading-none"></i>
            <span className="leading-none">Manage Requests</span>
          </button>
        )}
      </div>

      <div className="flex flex-col gap-4">
        <LeavesInfo leaveData={leaveInfo} />
        <LeavesStatusTable tableData={leavesDetail} tableHeading="Leaves Details" />
      </div>
    </div>
  );
};

export default LeavesDetails;